import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Fields, reduxForm, change } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import {
  generateValidation,
  registerDatePickerLocale,
  InputBlock,
} from 'ecs-react-components/dist/index.es';
import { validations } from './ActivityLog.validations';
import { messages } from './ActivityLog.i18n';
import { getActivityLogUrl } from '../../redux/modules/activity-log/activity-log-middleware';

export const fields = ['startDate', 'endDate'];

class ActivityLog extends React.Component {
  componentDidMount = () => {
    registerDatePickerLocale(this.props.language);

    this.props.dispatch(change('ActivityLog', 'startDate', moment().add(-1, 'Y').toDate()));
    this.props.dispatch(change('ActivityLog', 'endDate', moment().toDate()));
  }

  onSubmit = (fieldValues) => {
    const {
      startDate,
      endDate,
    } = fieldValues;

    this.props.dispatch(getActivityLogUrl(startDate, endDate))
      .then(
        (url) => {
          window.open(this.getBaseUrl() + url);
        });
  }

  getBaseUrl = () =>
    ('//'.concat(window.equicareLocalConfiguration.apiUrl.hostname).concat(':')
      .concat(window.equicareLocalConfiguration.apiUrl.port));

  renderFields = (fieldsMeta) => {
    const {
      startDate,
      endDate,
    } = fieldsMeta;

    return (
      <div className="row row-cols-auto mb-3">
        <div className="col">
          <div className="form-group">
            <InputBlock
              labelText={ <FormattedMessage { ...messages.label.startDate } /> }
              type="date"
              field={startDate}
              formGroup={false}
              onChange={startDate.input.onChange}
              language={this.props.language}
              labelClassName="bold"
            />
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <InputBlock
              labelText={ <FormattedMessage { ...messages.label.endDate } /> }
              type="date"
              field={endDate}
              formGroup={false}
              onChange={endDate.input.onChange}
              language={this.props.language}
              labelClassName="bold"
            />
          </div>
        </div>
      </div>
    );
  }

  render = () => (
    <div className="settings-section row" id="activity-log-body">
      <h4 id="activity-log-content" className="mt-2" tabIndex="0" role="form">
        <span className="title"><FormattedMessage { ...messages.label.title } /></span>
      </h4>
      <p tabIndex="0"><FormattedMessage { ...messages.label.instructions1 } /></p>
      <p tabIndex="0"><FormattedMessage { ...messages.label.instructions2 } /></p>
      <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <Fields names={fields} component={this.renderFields} />
        <button
          type="submit"
          data-qa-item="view-activity-log"
          data-toggle="modal"
          data-target="#viewactivitylog"
          className="btn btn-primary"
        >
          <FormattedMessage { ...messages.button.viewActivityLog } />
        </button>
      </form>
    </div>);
}

const formConfig = {
  form: 'ActivityLog',
  ...generateValidation(validations),
};

ActivityLog.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  language: PropTypes.string,
};

const mapStateToProps = (state) => (
  {
    language: state.language.languageCode,
  }
);

export default reduxForm(formConfig)(connect(mapStateToProps)(ActivityLog));
